module.exports = __webpack_public_path__ + "img/em3.313c3118.png";